import { render, staticRenderFns } from "./GroupsCourse.vue?vue&type=template&id=6eb89535&"
import script from "./GroupsCourse.vue?vue&type=script&lang=js&"
export * from "./GroupsCourse.vue?vue&type=script&lang=js&"
import style0 from "./GroupsCourse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GroupsCourse.vue"
export default component.exports